import { render } from "./ContainerMountPaths.vue?vue&type=template&id=6f6d50ae"
import script from "./ContainerMountPaths.vue?vue&type=script&lang=js"
export * from "./ContainerMountPaths.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__